export default __webpack_public_path__ + "static/clusterbuild1-1ee6b93976b0f008a3ed90ee572fcd23.png";